const formatNumber = (number) => number.toLocaleString('es-ES')

export default formatNumber
